import { useContext } from "react";

import { DispatchContext, DispatchShown, LazyState, LazyStateContext, State, StateContext } from "./reducer";

export function useShown(): State {
    const context = useContext(StateContext);

    if (context === undefined) {
        throw new Error("useShown must be used within a ShownProvider");
    }

    return context;
}

export function useLazyShown(): LazyState {
    const context = useContext(LazyStateContext);

    if (context === undefined) {
        throw new Error("useLazyShown must be used within a ShownProvider");
    }

    return context;
}

export function useDispatchShown(): DispatchShown {
    const context = useContext(DispatchContext);

    if (context === undefined) {
        throw new Error("useDispatchShown must be used within a ShownProvider");
    }

    return context;
}
